// extracted by mini-css-extract-plugin
export default {"JobDetails":"JobDetails_JobDetails__PsqfA","JobDetails__tag":"JobDetails_JobDetails__tag__Ybtav","tag":"JobDetails_tag__Imyi7","editIcon":"JobDetails_editIcon__ARnCE"};